import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "antd";
import React from "react";
export var VALIDATION_MESSAGE = {
    EMPTY: function (field, message) {
        return React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: "fix-icon-top-1-px color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } }),
            " ",
            message ? message : "".concat(field, " cannot be empty."));
    },
    REQUIRED: function (field, message) {
        return React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: "fix-icon-top-1-px color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } }),
            " ",
            message ? message : "Required field");
    },
    INVALID: function (field, message) {
        return React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: "fix-icon-top-1-px color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } }),
            " ",
            message ? message : "".concat(field, " is not valid."));
    },
    MAX_LIMIT: function (field, limit, item, message) {
        if (limit === void 0) { limit = 250; }
        if (item === void 0) { item = "characters"; }
        return React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: "fix-icon-top-1-px color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } }),
            " ",
            message ? message : "".concat(field, " can't exceed ").concat(limit, " ").concat(item, "."));
    },
    MIN_LIMIT: function (field, limit, item, message) {
        if (item === void 0) { item = "characters"; }
        return React.createElement(React.Fragment, null,
            React.createElement(Icon, { className: "fix-icon-top-1-px color-pink", component: function () { return React.createElement(FontAwesomeIcon, { icon: faExclamationCircle }); } }),
            " ",
            message ? message : "".concat(field, " can't be less than ").concat(limit, " ").concat(item, "."));
    },
};
//# sourceMappingURL=message.js.map